import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Toast } from "../../../components/Common/Toast";
import { getTrainingVideosService, updateTrainingVideosService, validateTrainingVideos } from "./services/TrainingVideos.service";
import LoadingSpinner from "../../../components/LoadingSpinner/LoadingSpinner";
import TrainingVideosForm from "./components/TrainingVideosForm";
import { TokenCookieManager } from "../../../utils/tokenCookies";
import { HTTPStatusEnum } from "../../../interfaces/log.interface";

export interface VideoLinks {
    links: {
        STORY_CHARCTER_BUILDER_VIDEO: string;
        STORY_EDITOR_VIDEO: string;
        STORY_PURCHASE_AND_VIEW_VIDEO: string;
        STORY_INTRO_VIDEO: string;
    };
}

const TrainingVideos = () => {
    const [loader, setLoader] = useState(true);
    const [disable, setDisable] = useState(false);
    const [TrainingVideos, setTrainingVideos] = useState<VideoLinks>({} as VideoLinks);
    const navigate = useNavigate();

    useEffect(() => {
        if (!TokenCookieManager.hasToken()) {
            navigate("/admin");
        }
    });

    const getTrainingVideos = async () => {
        try {
            setLoader(true);
            const videos = await getTrainingVideosService();
            if (Object.keys(videos)?.length > 0) {
                setTrainingVideos(videos);
            } else {
                Toast("No Training Videos Found", true);
            }
        } finally {
            setLoader(false);
        }
    };

    const handleSubmit = async () => {
        try {
            setDisable(true);
            setLoader(true);

            const validationResult = await validateTrainingVideos(TrainingVideos);

            if (!validationResult.valid) {
                Toast("Valid Youtube links required!", true);
            } else {
                const response = await updateTrainingVideosService(TrainingVideos);
                if (response?.status === HTTPStatusEnum.OK) {
                    Toast("Training Videos Updated Successfully!", false);
                } else {
                    Toast("Something Went Wrong!", true);
                }
            }
        } catch (error) {
            Toast("Something Went Wrong!", true);
        } finally {
            setDisable(false);
            setLoader(false);
        }
    };

    useEffect(() => {
        getTrainingVideos();
    }, []);

    function formatLabel(label: string) {
        return label
            .toLowerCase()
            .split("_")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");
    }

    const handleInputChange = (key: string, value: string) => {
        setTrainingVideos((prev) => ({
            ...prev,
            [key]: value,
        }));
    };
    const goBack = () => {
        navigate(-1);
    };

    return (
        <div>
            <div className="">
                <p className="text-left pl-4 ">
                    For smooth integration of training videos for users, only add "embed" links from youtube
                </p>
                {loader ? (
                    <LoadingSpinner />
                ) : (
                    <>
                        <form
                            id="training-videos-form"
                            name="training-videos-form"
                            className="mt-2 text-start "
                            onSubmit={(e) => {
                                e.preventDefault();
                                handleSubmit();
                            }}
                        >
                            <TrainingVideosForm
                                TrainingVideos={TrainingVideos}
                                handleInputChange={handleInputChange}
                                formatLabel={formatLabel}
                                loader={loader}
                                disable={disable}
                                goBack={goBack}
                            />
                        </form>
                    </>
                )}
            </div>
        </div>
    );
};

export default TrainingVideos;
